// Mock data for HVGTEC website

export const companyInfo = {
  name: "HVGTEC",
  tagline: "Bridging the Digital Divide",
  description: "HVGTEC bridges the digital divide in Southern Leyte and beyond. We provide tiered ISP packages ranging from 120-client Micro POPs to 4,000+ client Carrier Cores, utilizing OSPF, BGP, and VPLS protocols to ensure maximum uptime and scalability. We also offer quality subscription plans in Southern Leyte for our FTTH distribution, with plans ranging from 20 to 50 Mbps for residential use.",
  location: "Southern Leyte, Philippines",
  email: "hvgnetworks@gmail.com",
  phone: "+63 123 456 7890",
  socialMedia: {
    facebook: "https://www.facebook.com/FiberStreamMain",
    linkedin: "https://linkedin.com/company/hvgtec",
    twitter: "https://twitter.com/hvgtec"
  },
  messenger: "https://m.me/FiberStreamMain",
  whatsapp: "+63 123 456 7890",
  telegram: "https://t.me/hvgtec"
};

export const services = [
  {
    id: 1,
    title: "Headend-in-a-Box Solutions",
    description: "Complete network core infrastructure solutions designed for scalability and reliability. Pre-configured, tested, and ready for deployment.",
    icon: "Server",
    features: ["Turnkey deployment", "Carrier-grade reliability", "Scalable architecture", "24/7 monitoring"]
  },
  {
    id: 2,
    title: "FTTH Infrastructure",
    description: "End-to-end Fiber-to-the-Home network design and deployment services. From planning to installation and maintenance.",
    icon: "Cable",
    features: ["Network design", "Installation", "Maintenance", "Quality assurance"]
  },
  {
    id: 3,
    title: "Network Architecture",
    description: "Carrier-grade network design using industry-leading protocols including OSPF, BGP, and VPLS for maximum uptime.",
    icon: "Network",
    features: ["OSPF routing", "BGP peering", "VPLS implementation", "High availability"]
  },
  {
    id: 4,
    title: "Solar-Powered Micro POPs",
    description: "Off-grid network infrastructure solutions powered by solar energy, perfect for remote and typhoon-prone regions.",
    icon: "Sun",
    features: ["Solar-powered", "Off-grid capable", "Weather-resistant", "Remote deployment"]
  },
  {
    id: 5,
    title: "Systems Integration",
    description: "Complete integration services for Ubiquiti, MikroTik, and Juniper equipment into your existing infrastructure.",
    icon: "Cpu",
    features: ["Multi-vendor support", "Seamless integration", "Performance optimization", "Technical support"]
  },
  {
    id: 6,
    title: "ISP Consultation",
    description: "Expert consultation services for starting and scaling your ISP business with proven strategies and technical guidance.",
    icon: "Users",
    features: ["Business planning", "Technical guidance", "Regulatory compliance", "Market analysis"]
  }
];

export const franchiseModels = [
  {
    id: 1,
    name: "Micro POP - Barangay Starter",
    capacity: "120 Clients",
    description: "Perfect for small communities and barangays. Solar-powered and off-grid capable with rapid deployment.",
    investment: "₱241,000",
    roi: "6-7 months",
    roiNote: "at full capacity",
    features: [
      "Energy independence (1.5kW solar system)",
      "120 concurrent subscribers",
      "Off-grid capable with LiFePO4 battery",
      "3km fiber backbone infrastructure",
      "Cybersecure headend with ISP OS",
      "Plug-and-play deployment",
      "Full installation included"
    ],
    hardware: [
      "HVGTEC Security Gateway & 1-Port OLT (128 sub capacity)",
      "450W Solar Panel + 1kW Inverter",
      "2.4kWh LiFePO4 Battery Bank",
      "3km Single-Core Fiber + 8 NAP Boxes"
    ],
    revenue: "₱120,000/month",
    revenueNote: "at 100% saturation"
  },
  {
    id: 2,
    name: "Micro POP - Town Center Hub",
    capacity: "250 Clients",
    description: "Ideal for town centers and high-density areas. Carrier-grade with dual-router redundancy and 99.9% uptime.",
    investment: "₱402,000",
    roi: "5-6 months",
    roiNote: "at full capacity",
    features: [
      "Carrier-grade reliability (2.4kW solar array)",
      "250 concurrent subscribers",
      "Dual-router redundancy architecture",
      "6km fiber backbone infrastructure",
      "Business-class ISP OS cloud management",
      "99.9% uptime guarantee",
      "Full installation included"
    ],
    hardware: [
      "Cloud Gateway + Dual-Router + 2-Port OLT",
      "2x 450W Solar Panels + 2.4kW Inverter",
      "4.8kWh LiFePO4 Battery Bank",
      "6km Single-Core Fiber + 16 NAP Boxes"
    ],
    revenue: "₱250,000/month",
    revenueNote: "at 100% saturation",
    popular: true
  },
  {
    id: 3,
    name: "Regional Core",
    capacity: "4,000+ Clients",
    description: "Enterprise-grade infrastructure for cities and large coverage areas. Full carrier-grade implementation.",
    investment: "₱8,000,000 - ₱15,000,000",
    roi: "14-24 months",
    roiNote: "varies by market",
    features: [
      "Carrier-grade Juniper equipment",
      "4,000+ concurrent users",
      "BGP, OSPF, VPLS protocols",
      "Multiple redundant paths",
      "Enterprise NOC",
      "Dedicated support team"
    ],
    hardware: ["Juniper MX series", "Carrier-grade switches", "Enterprise power systems", "Advanced monitoring"],
    revenue: "₱1,200,000 - ₱2,000,000/month",
    revenueNote: "market dependent"
  }
];

export const subscriptionPlans = {
  premium: [
    {
      id: 1,
      name: "FiberStream Premium 50",
      speed: "Up to 50 Mbps",
      price: "₱1,599",
      description: "Ultimate connectivity for power users and large households",
      features: [
        "Up to 50 Mbps speed",
        "Unlimited data",
        "Low latency",
        "Smart bandwidth management",
        "Up to 30 users",
        "Priority support",
        "Free installation (2-year contract)"
      ],
      popular: true
    },
    {
      id: 2,
      name: "FiberStream Premium 30",
      speed: "Up to 30 Mbps",
      price: "₱1,299",
      description: "Perfect for streaming, gaming, and work-from-home",
      features: [
        "Up to 30 Mbps speed",
        "Unlimited data",
        "Low latency",
        "Smart bandwidth management",
        "Up to 25 users",
        "Priority support",
        "Free installation (2-year contract)"
      ]
    },
    {
      id: 3,
      name: "FiberStream Premium 20",
      speed: "Up to 20 Mbps",
      price: "₱999",
      description: "Reliable speed for families and small offices",
      features: [
        "Up to 20 Mbps speed",
        "Unlimited data",
        "Low latency",
        "Smart bandwidth management",
        "Up to 20 users",
        "24/7 support",
        "Free installation (2-year contract)"
      ]
    }
  ],
  economy: [
    {
      id: 4,
      name: "FiberStream Economy 10 Plus",
      speed: "Up to 10 Mbps",
      price: "₱899",
      description: "Great value for moderate browsing and streaming",
      features: [
        "Up to 10 Mbps speed",
        "Unlimited data",
        "Smart bandwidth management",
        "Up to 8 users",
        "24/7 support",
        "No cash-out installation (6-month spread)"
      ]
    },
    {
      id: 5,
      name: "FiberStream Economy 10 Standard",
      speed: "Up to 10 Mbps",
      price: "₱699",
      description: "Affordable internet for small households",
      features: [
        "Up to 10 Mbps speed",
        "Unlimited data",
        "Smart bandwidth management",
        "Up to 6 users",
        "24/7 support",
        "No cash-out installation (6-month spread)"
      ]
    },
    {
      id: 6,
      name: "FiberStream Economy 10 Basic",
      speed: "Up to 10 Mbps",
      price: "₱599",
      description: "Budget-friendly connectivity for essential needs",
      features: [
        "Up to 10 Mbps speed",
        "Unlimited data",
        "Smart bandwidth management",
        "Up to 4 users",
        "Standard support",
        "No cash-out installation (6-month spread)"
      ]
    }
  ]
};

export const hardware = [
  {
    id: 1,
    brand: "Ubiquiti",
    model: "EdgeRouter & UniFi Series",
    category: "Core Routing & Management",
    description: "Enterprise-grade routing platform with advanced features for ISPs. UniFi ecosystem provides seamless management.",
    specs: ["Hardware acceleration", "OSPF/BGP support", "VPN capabilities", "QoS management", "UniFi Controller integration"],
    useCases: ["Micro POP", "Community deployments"]
  },
  {
    id: 2,
    brand: "MikroTik",
    model: "CCR & RB Series",
    category: "Routing & Switching",
    description: "Powerful and cost-effective routing solutions with RouterOS.",
    specs: ["Multi-core processing", "MPLS/VPLS support", "Advanced firewall", "Traffic shaping"],
    useCases: ["All deployment sizes", "Flexible configurations"]
  },
  {
    id: 3,
    brand: "Juniper",
    model: "MX & EX Series",
    category: "Carrier-Grade",
    description: "Industry-leading carrier-grade routing and switching platforms.",
    specs: ["Carrier-class reliability", "Full protocol suite", "Scalable architecture", "Advanced security"],
    useCases: ["Regional Core", "Enterprise deployments"]
  },
  {
    id: 4,
    brand: "Netgate",
    model: "pfSense Plus Appliances",
    category: "Firewall & Security",
    description: "Enterprise-grade firewall and VPN solutions built on pfSense open-source platform.",
    specs: ["Stateful firewall", "VPN concentrator", "IDS/IPS integration", "High availability"],
    useCases: ["Security perimeter", "VPN gateway"]
  },
  {
    id: 5,
    brand: "Mimosa Networks",
    model: "B5x & C5x Series",
    category: "Wireless Backhaul",
    description: "High-performance wireless backhaul solutions for long-distance PtP and PtMP deployments.",
    specs: ["GPS synchronization", "Spectrum reuse", "Up to 1.5 Gbps", "Auto-channel selection"],
    useCases: ["Wireless backhauls", "Long-span links"]
  }
];

export const resilienceFeatures = [
  {
    id: 1,
    title: "Solar-Powered Infrastructure",
    description: "Our Micro POPs can run entirely on solar energy with battery backup, ensuring 24/7 operation even during grid outages.",
    icon: "Sun",
    benefits: ["Zero electricity costs", "100% uptime guarantee", "Eco-friendly operation", "Grid-independent"]
  },
  {
    id: 2,
    title: "Multi-Path Hybrid Resilience",
    description: "Built from years of operating in harsh Philippine conditions—engineered to stay online when others fail through Hybrid Power Architecture, Fiber-Wireless Overlay, and Hazard-Averse Engineering.",
    icon: "Layers",
    benefits: ["Grid + Solar + LiFePO4 power", "Fiber-Wireless dual-path redundancy", "Wireless backhauls for long spans", "Zero single-point failures"]
  },
  {
    id: 3,
    title: "Redundant Connectivity",
    description: "Multiple uplink paths and automatic failover ensure continuous service even if one connection fails.",
    icon: "RefreshCw",
    benefits: ["Automatic failover", "Load balancing", "99.9% uptime", "Zero packet loss"]
  },
  {
    id: 4,
    title: "Remote Management",
    description: "Full remote monitoring and management capabilities allow quick response to any issues without on-site visits.",
    icon: "Monitor",
    benefits: ["24/7 monitoring", "Instant diagnostics", "Remote updates", "Proactive maintenance"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ricardo Santos",
    role: "Micro POP Franchise Owner",
    location: "Barangay San Juan, Southern Leyte",
    content: "HVGTEC's solar-powered Micro POP solution transformed our barangay. Even during typhoon Odette, we maintained connectivity while neighboring areas were offline for weeks. The ROI was achieved in 14 months!",
    rating: 5
  },
  {
    id: 2,
    name: "Maria Gonzales",
    role: "Municipal Administrator",
    location: "Sogod, Southern Leyte",
    content: "The Community Core deployment exceeded our expectations. With 500+ households connected, the reliability and speed are outstanding. HVGTEC's support team is always responsive and professional.",
    rating: 5
  },
  {
    id: 3,
    name: "James Villanueva",
    role: "Regional ISP Partner",
    location: "Maasin City",
    content: "Scaling from Micro POP to Regional Core was seamless with HVGTEC. Their carrier-grade infrastructure using Juniper equipment handles 3,500+ clients without issues. Best investment decision we made.",
    rating: 5
  }
];

export const aboutStats = [
  { label: "Years of Experience", value: "8+", icon: "Calendar" },
  { label: "Active Deployments", value: "150+", icon: "MapPin" },
  { label: "Clients Served", value: "45,000+", icon: "Users" },
  { label: "Network Uptime", value: "99.9%", icon: "Activity" }
];

export const technicalSpecs = {
  protocols: ["OSPF", "BGP", "VPLS", "MPLS", "802.11ac/ax", "IPv6", "SD-WAN"],
  vendors: ["Ubiquiti", "MikroTik", "Juniper", "Cambium Networks", "Netgate/pfSense", "Mimosa Networks", "Dahua", "Hikvision", "Starlink"],
  certifications: {
    networking: [
      "APNIC Certified (BGP & IPv6)",
      "UniFi Network Professional",
      "UniFi Routing/Switching Admin",
      "UniFi Cybersecurity Admin"
    ],
    mikrotik: ["MTCNA", "MTCRE", "MTCTCE", "MTCWE"],
    wireless: ["Mimosa Wireless Certified"],
    security: [
      "Dahua Certified Solutions Associate",
      "Dahua Certified Solutions Professional",
      "Hikvision Certified Security Professional"
    ],
    ai: ["Google Cloud Generative AI", "Sololearn Generative AI in Practice"]
  },
  unifiEcosystem: {
    networking: ["Gateways (UDM/UXG)", "Switching (Enterprise/Lite)", "High-Density APs (U6/U7)"],
    applications: ["Protect (Surveillance)", "Access (Entry Control)", "Talk (VoIP)", "Connect (Digital Signage)"],
    design: ["UniFi InnerSpace (Floor-plan wireless & signal modeling)"]
  },
  capabilities: [
    "Carrier-grade routing",
    "Off-grid deployment",
    "FTTH installation",
    "24/7 NOC",
    "Advanced Cybersecurity Auditing",
    "AI Solutions Integration",
    "Integrated Smart Building Solutions",
    "Enterprise Security Systems",
    "Unified Communications",
    "Rapid Deployment Satellite Solutions",
    "Starlink Business & Enterprise Integration"
  ],
  aiInnovation: {
    title: "AI & Digital Innovation",
    description: "Deployed AI-driven Customer Service Representatives (CSRs) for internal and enterprise client operations.",
    implementations: [
      "AI-powered customer support chatbots",
      "Intelligent network monitoring alerts",
      "Automated ticket classification & routing"
    ]
  },
  starlink: {
    deployments: "50+",
    description: "HVGTEC has pioneered Starlink deployments in the region, integrating satellite connectivity as high-speed failover backhaul for Micro POP nodes.",
    features: [
      "Starlink Business & Enterprise Integration",
      "OSPF/SD-WAN bonding with existing ISP backhauls",
      "Critical connectivity during extreme weather",
      "Rapid deployment for remote areas"
    ]
  },
  technologyPartners: [
    { name: "Ubiquiti", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Ubiquiti_Logo.svg/200px-Ubiquiti_Logo.svg.png" },
    { name: "MikroTik", logo: "https://mikrotik.com/img/mtv2/newlogo.svg" },
    { name: "Juniper", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Juniper_Networks_logo.svg/200px-Juniper_Networks_logo.svg.png" },
    { name: "Dahua", logo: "https://www.dahuasecurity.com/asset/upload/image/20210714/Dahua-logo.png" },
    { name: "Hikvision", logo: "https://www.hikvision.com/content/dam/hikvision/en/marketing/image/latest-news/20210816/Web-banner.png" },
    { name: "Starlink", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Starlink_Logo.svg/200px-Starlink_Logo.svg.png" }
  ]
};
